<template>
  <li class="member">
    <p
      :style="`padding-left: ${depth}em`"
      @mouseenter="showToolbar=true"
      @mouseleave="showToolbar=false"
    >
      <!-- 头像 -->
      <img
        class="avatar"
        src="@/assets/home/address_book/default_avatar.png"
      >
      <!-- 成员名字 -->
      <a
        class="name"
        target="_blank"
        :href="`XMPP:${member.SamAccountName}@royole.com`"
        :title="member.SamAccountName"
      >
        {{ member.DisplayName }}
      </a>
      <Font v-show="showToolbar">
        <!-- 收藏按钮 -->
        <a
          href="javascript:void(0);"
          class="tool-icon"
          title="点击收藏"
        >
          <i class="fa fa-star-o" />
        </a>
        <!-- 邮箱按钮 -->
        <a
          v-if="member.EmailAddress"
          :href="`mailto:${member.EmailAddress}`"
          :title="member.EmailAddress"
          class="tool-icon"
        >
          <i class="fa fa-envelope-o" />
        </a>
      </Font>
    </p>
  </li>
</template>

<script>
export default {
  props: {
    member: {
      type: Object,
      default: () => { },
    },
    depth: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      showToolbar: false,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.member {
  .avatar {
    margin-right: 3px;
    width: 20px;
    height: 20px;
    vertical-align: middle;
  }
  &:hover {
    border-radius: 1px;
    background-color: $hover-color;
  }
  p {
    margin-left: 18px;
    height: 36px;
    line-height: 36px;
    color: $info;
    font-size: 14px;
    .name {
      cursor: pointer;
      &:hover {
        color: $danger;
      }
    }
    .tool-icon {
      float: right;
      margin-right: 8px;
      font-size: 12px;
      color: #4865cd;
      cursor: pointer;
      &:hover {
        color: $danger;
      }
    }
  }
}
</style>
